<template>
  <div class="view-container">
    <div v-if="study" class="view-gabarit">
      <div class="view-row">
        <span class="baseline">{{ $t('studyCreation.studyRecap') }}</span>
      </div>

      <Parameters :study="study" />

      <form @submit.prevent="submitForm">
        <div v-if="actualSites.length > 0" class="sites-container">
          <p class="site-category">{{ $t('actualSites', actualSites.length) }}</p>
          <div v-for="data in actualSites" :key="data.id" class="site-box">
            <span class="poi" :style="{ 'background-image': `url('${data.poi}')` }"></span>
            <div class="details">
              <span class="title">{{ data.name }}</span>
              <span class="address">{{ data.address }}</span>
            </div>
          </div>
        </div>

        <div v-if="targetSites.length > 0" class="sites-container">
          <p class="site-category">{{ $t('futureSite', targetSites.length) }}</p>
          <div v-for="data in targetSites" :key="data.id" class="site-box target-site">
            <span class="poi" :style="{ 'background-image': `url('${data.poi}')` }"></span>
            <img class="site-picture" :src="data.image" alt="" />
            <div class="details">
              <span class="title">{{ data.name }}</span>
              <span class="address">{{ data.address }}</span>
            </div>
          </div>
        </div>

        <div class="fieldset button-container">
          <button class="study-button main" type="submit">{{ $t('generateStudy') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Parameters from '@/components/Study/Parameters';
import assetProvider from '@/pure/assetProvider';

export default {
  components: {
    Parameters,
  },

  data() {
    return {
      study: false,
    };
  },

  computed: {
    sites() {
      return this.study
        ? this.study.sites.map(site => {
            const poi = site.type === 1 ? assetProvider.poiHome : assetProvider[`poi${site.order + 1}`];
            const image = site.type === 1 ? null : site.picture_path || assetProvider.placeHolderSite;
            return {
              id: site.id,
              name: site.name,
              address: site.address.formatted,
              type: site.type,
              poi,
              image,
            };
          })
        : [];
    },

    actualSites() {
      return this.sites.filter(item => item.type === 1);
    },

    targetSites() {
      return this.sites.filter(item => item.type === 2);
    },
  },

  mounted() {
    const id = this.$route.params.studyId;
    this.$store.dispatch('getStudy', { id }).then(response => {
      this.study = response;
    });
  },

  methods: {
    submitForm() {
      const id = this.$route.params.studyId;

      this.$store.dispatch('startProcessing', { id }).then(() => {
        this.$router.push({ name: 'studyStatus' });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

form {
  display: flex;
  padding-bottom: 60px;
}
.fieldset {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.sites-container {
  flex: 1;
  margin: 0 3em 0 1em;
}
.site-category {
  font-size: 16px;
  font-weight: 600;
}
.site-box {
  display: flex;
  position: relative;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 6px;
  height: 57px;
  border-bottom: 1px solid #e3e3e3;
  &:first-of-type {
    border-top: 1px solid #e3e3e3;
  }
}
.poi {
  height: 43px;
  display: inline-block;
  width: 29px;
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  box-sizing: border-box;

  .target-site & {
    position: absolute;
    top: 32px;
    left: -4px;
  }
}
.site-picture {
  height: 57px;
  max-width: 75px;
  width: auto;
  border-radius: 0.625em;
}
.current-site-picture {
  max-width: 75px;
  width: auto;
}
.details {
  padding-left: 1em;
  span {
    display: block;
    &.title {
      font-size: 16px;
      font-weight: 700;
    }
    &.address {
      font-size: 14px;
      color: #77797f;
    }
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .fieldset.button-container {
    display: block;
    padding: 48px 0 0;
  }
}
</style>
